@use 'src/styles/config.module' as config;
@mixin scrollbar {
  &::-webkit-scrollbar {
    background-color: rgba(gray, 0.2);
  }
  &::-webkit-scrollbar-track {
    background-color: rgba(config.$color-grey, 0.1);
  }
  &::-webkit-scrollbar-thumb {
    background-color: config.$color-secondary;
    &:hover {
      background-color: config.$color-secondary;
    }
  }
}
.root {
  position: relative;
  height: 100%;
  .wrapper {
    //position: absolute;
    height: 100%;
    width: 100%;
    cursor: auto;
  }
  &::-webkit-scrollbar {
    width: 0.6rem;
    height: 0.6rem;
    background-color: transparent;
    border-radius: 0.6rem;
    cursor: pointer;
  }
  &::-webkit-scrollbar-track {
    border-radius: 0.4rem;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 0.7rem;
    background-color: transparent;
  }
  &.all,
  &:hover {
    @include scrollbar;
  }
  &.hide .wrapper {
    overflow: hidden;
  }
}
